import { useState, useEffect } from "react";
import { useData } from "./DataContext.js";

import Markdown from "react-markdown";
import RehypeRaw from "rehype-raw";
import RemarkGfm from "remark-gfm";

import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";

import { BsFillFileEarmarkTextFill, BsFillChatTextFill } from "react-icons/bs";
import { Draggable } from "react-beautiful-dnd";

import DocumentTitle from "./DocumentTitle.js";
import MarkdownComponents from "./MarkdownComponents.js";


const documentStyle = { width: "40%", maxWidth: "40%" };
const adviceStyle = { width: "500px", maxWidth: "500px" };


export default function DocumentDraggable (props)
{
    const gData = useData();

    const [fileContent, setFileContent] = useState("__Chargement en cours...__");
    const documentContent = gData.content.documents[props.documentId];

    useEffect(() => {
	const src = gData.gameId + "/documents/" + documentContent.id + "." + documentContent.ext;
	if (documentContent.ext === "md")
	{
	    fetch(src)
		.then((response) => { return response.text(); })
		.then((text) => { setFileContent(text); });
	}

	else if (documentContent.ext === "jpg")
	{
	    setFileContent("<img src='" + src + "' width='100%'/>");
	}
    }, [gData.gameId, documentContent]);
    
    let documentShortTitle = (<></>);
    let documentLongTitle = (<></>);
    if (documentContent.type === "document")
    {
	documentShortTitle = (<span>{documentContent.title}</span>);
	documentLongTitle = documentShortTitle;
    }
    
    if (documentContent.type === "advice")
    {
	const char = gData.content.chars[documentContent.charId];
	documentShortTitle = (<span>Avis {char.shortTitle}</span>);
	documentLongTitle = (<span>Avis {char.gender === "M" ? "du" : "de la"} {char.title}</span>);
    }

    const disabled = gData.state.reports[documentContent.solutionId].result !== null;

    return (
	<Draggable draggableId={props.documentId} index={props.index} isDragDisabled={disabled}>
	    {(provided, snapshot) => {

		// CURRENT VALUE
		let value = props.value === undefined ? "collection" : props.value;
		if (snapshot.draggingOver !== null)
		{
		    const [ overSolutionId, overVariableId, overValue ] = snapshot.draggingOver.split("/");
		    value = overValue;
		}

		const popover = (
		    <Popover className="shadow" style={documentContent.type === "document" ? documentStyle : adviceStyle}>
			<Popover.Header className="d-flex align-items-center gap-2">
			    {documentContent.variableId === null && (<BsFillFileEarmarkTextFill className={"fs-4"}/>)}
			    {(documentContent.variableId !== null && documentContent.type === "document") && (<BsFillFileEarmarkTextFill className={"fs-4"}/>)}
			    {(documentContent.variableId !== null && documentContent.type === "advice") && (<BsFillChatTextFill className={"fs-4"}/>)}
			    <span className="fs-5">{documentLongTitle}</span>
			</Popover.Header>
			<Popover.Body>
			    {documentContent.type === "document" && (<div><Markdown components={MarkdownComponents} remarkPlugins={[ RemarkGfm ]} rehypePlugins={[ RehypeRaw ]}>{fileContent}</Markdown></div>)}
			    {documentContent.type === "advice" && (<div className="fs-6">{documentContent.content}</div>)}
			</Popover.Body>
		    </Popover>
		);
		
		return (
		    <OverlayTrigger placement="auto" overlay={popover}>
			<div { ...provided.draggableProps } { ...provided.dragHandleProps } ref={provided.innerRef} className="pb-1 pe-1">
			    <DocumentTitle documentId={props.documentId} variableId={props.variableId} value={value} size="sm"/>
			</div>
		    </OverlayTrigger>
		);
	    }}
	</Draggable>
    );
}
